import Steps from './steps.vue'
import Step from './step.vue'

export default (Vue) => {
  Vue.component(Steps.name, Steps)
  Vue.component(Step.name, Step)
}
